import { Tracker } from '@pegasus/tracker';
export var tracker = new Tracker();
